import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'AJOUT_ETAB',
  title: 'Wie registriere ich meine anderen Organisationen?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn Sie mehrere Organisationen haben, können auch diese ihre Dokumente auf der Plattform einreichen. Führen Sie einfach die folgenden Schritte aus:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie oben links auf Ihren Firmennamen und lassen Sie sich das Dropdown-Menü anzeigen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_AJOUT_ETAB/DE_AJOUT_ETAB_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Dann klicken Sie auf "Neue Firma anlegen"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_AJOUT_ETAB/DE_AJOUT_ETAB_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Geben Sie dann die Betriebsnummer der Firma ein, die Sie hinzufügen möchten, und klicken Sie auf "Weiter"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_AJOUT_ETAB/DE_AJOUT_ETAB_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Geben Sie dann die Betriebsnummer der Firma ein, die Sie hinzufügen möchten, und klicken Sie auf "Weiter"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_AJOUT_ETAB/DE_AJOUT_ETAB_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Sobald die Informationen vollständig sind, wird Ihr Antrag auf Hinzufügung bearbeitet. Sie werden dann per E-Mail benachrichtigt.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_AJOUT_ETAB/DE_AJOUT_ETAB_5.png`
  }]
};
